const GroupPoliciesStatus = {
    1: "کپی",
    2: "کپی متصل",
    3: "قالب",
}

export default GroupPoliciesStatus;